import React from "react";
import { Link } from "react-router-dom";
import SlideMenu from "../components/SlideMenu";
import { useState } from "react";
import { useDarkMode } from "../contexts/DarkModeContext";

function TopBar({ link }) {
  const [isDisplay, setDisplay] = useState(false);
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  const handleClose = () => {
    setDisplay(!isDisplay);
  };

  return (
    <div className="mb-3 flex h-16 items-center justify-center border-b border-stone-200 bg-white dark:border-slate-700 dark:bg-slate-900">
      <SlideMenu
        isDisplay={isDisplay}
        setDisplay={handleClose}
        setIsDisplay={setDisplay}
      ></SlideMenu>
      {link && (
        <div className="ml-3">
          <Link to={link}>
            <button className="flex items-center justify-center rounded-lg p-2 text-stone-600 hover:bg-stone-100 dark:text-slate-300 dark:hover:bg-slate-800">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                />
              </svg>
            </button>
          </Link>
        </div>
      )}
      <div className="grow"></div>
      <div className="w-[1400px]">
        <Link to="/">
          <div className="flex cursor-pointer items-center">
            <div className="mr-3">
              <img src="/logo_header.png" className="h-12"></img>
            </div>
            <div className="flex flex-col">
              <span className="font-fira text-2xl font-bold dark:text-white">Check'veau</span>
              <span className="-translate-y-1 text-xs text-stone-500 dark:text-slate-400">
                Par Grangeneuve (beta v.0.2)
              </span>
            </div>
          </div>
        </Link>{" "}
      </div>
      <div className="mr-3 flex grow justify-end items-center space-x-3">
        <button
          onClick={toggleDarkMode}
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          aria-label="Toggle dark mode"
        >
          {isDarkMode ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6 text-yellow-400">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6 text-stone-600">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
            </svg>
          )}
        </button>
        <button onClick={() => setDisplay(true)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6 dark:text-white"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default TopBar;
